import BaseModelAPI from '../BaseModelAPI';

export default class ReportPoSalesList extends BaseModelAPI {

	static entity = 'newreport1997list'
	static entityName = 'reportposales';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
